import { Component } from 'react';
import cx from 'classnames';
import styles from '../../styles/rent.scss';

export class WebForm extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      squizedForm1: true,
      squizedForm2: false,
    };
  }

  public handleFormClick = (e: any) => {
    if (this.props.data.showForm2) {
      e.persist();
      const targetValue = e.target.dataset.val;
      const parent1Value = e.target.parentNode.parentNode.dataset.val;
      const parent2Value =
        e.target.parentNode.parentNode.parentNode.dataset.val;
      const parent3Value = e.target.parentNode.dataset.val;
      if (targetValue || parent1Value || parent2Value || parent3Value) {
        if (
          targetValue === 'sub_form1' ||
          parent1Value === 'sub_form1' ||
          parent2Value === 'sub_form1' ||
          parent3Value === 'sub_form1'
        ) {
          this.setState({
            squizedForm1: false,
            squizedForm2: true,
          });
        }

        if (
          targetValue === 'sub_form2' ||
          parent1Value === 'sub_form2' ||
          parent2Value === 'sub_form2' ||
          parent3Value === 'sub_form2'
        ) {
          this.setState({
            squizedForm1: true,
            squizedForm2: false,
          });
        }
      }
    }
  };

  public handleSubmitClick = (e: any) => {
    this.props.handleSubmit(e, 'web');
  };

  public render() {
    const { showForm2 } = this.props.data;
    const { squizedForm1, squizedForm2 } = this.state;
    const { formErrors, formValid } = this.props;

    return (
      <form className={cx(styles['show-in-web'])}>
        <div
          id="form1"
          className={cx(
            styles['rentreceipt-form'],
            styles['rentreceipt-form1'],
            {
              [styles.squiz]: showForm2,
              [styles.expand]: squizedForm2,
              [styles.showUp]: squizedForm2,
              [styles.showDown]: !squizedForm2,
            }
          )}
          onClick={this.handleFormClick}
          data-val="sub_form1"
        >
          <div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.rent}</span>
              <input
                aria-required="true"
                name="Rent"
                type="tel"
                value={this.props.data.rent}
                onChange={this.props.handleChange}
                id="Rent"
              />
              <label className={cx(styles['active'])} htmlFor="Rent">
                What is your monthly rent?
              </label>
            </div>
          </div>
          <div>
            <div className={cx(styles['input-box'])}>
              <span className={cx(styles['error'])}>{formErrors.address}</span>
              <input
                aria-required="true"
                id="Address"
                name="Address"
                type="text"
                value={this.props.data.address}
                onChange={this.props.handleChange}
              />
              <label className={cx(styles['active'])} htmlFor="Address">
                What is the house address?
              </label>
            </div>
          </div>
          <div
            className={cx('text-center')}
            style={showForm2 ? { display: 'none' } : null}
          >
            <button
              className={cx('btn', styles['orange-btn'])}
              id="js-generate-receipts"
              name="submit"
              type="button"
              value=""
              onClick={this.props.toggleForm}
            >
              {'Proceed'.toUpperCase()}
            </button>
          </div>
        </div>
        {this.props.data.showForm2 ? (
          <div
            id="form2"
            className={cx(
              styles['rentreceipt-form'],
              styles['rentreceipt-form2'],
              {
                [styles.expand]: squizedForm1,
                [styles.squizzed]: squizedForm2,
                [styles.showUp]: squizedForm1,
                [styles.showDown]: !squizedForm1,
              }
            )}
            onClick={this.handleFormClick}
            data-val="sub_form2"
          >
            <div className={cx(styles['rentreceipt-subform'])}>
              <div className={cx(styles['input-box'])}>
                <span className={cx(styles['error'])}>{formErrors.name}</span>
                <input
                  aria-required="true"
                  id="Name"
                  name="Name"
                  type="text"
                  value={this.props.data.name}
                  onChange={this.props.handleChange}
                />
                <label className={cx(styles['active'])} htmlFor="Name">
                  What is your name?
                </label>
              </div>
              <div className={cx(styles['input-box'])}>
                <span className={cx(styles['error'])}>{formErrors.email}</span>
                <input
                  aria-required="true"
                  id="UserEnteredEmail"
                  name="Email"
                  type="email"
                  value={this.props.data.email}
                  onChange={this.props.handleChange}
                />
                <label
                  className={cx(styles['active'])}
                  htmlFor="UserEnteredEmail"
                >
                  What is your email?
                </label>
              </div>
            </div>
            <div className={cx(styles['rentreceipt-subform'])}>
              <div className={cx(styles['input-box'])}>
                <span className={cx(styles['error'])}>{formErrors.owner}</span>
                <input
                  aria-required="true"
                  id="HouseOwnerName"
                  name="Owner"
                  type="text"
                  value={this.props.data.owner}
                  onChange={this.props.handleChange}
                />
                <label
                  className={cx(styles['active'])}
                  htmlFor="HouseOwnerName"
                >
                  What is the name of your house owner?
                </label>
              </div>
              <div className={cx(styles['input-box'])}>
                <span className={cx(styles['error'])}>{formErrors.pan}</span>
                <input
                  className=""
                  id="HouseOwnerPan"
                  name="pan"
                  type="text"
                  value={this.props.data.pan}
                  onChange={this.props.handleChange}
                />
                <label className={cx(styles['active'])} htmlFor="HouseOwnerPan">
                  What is your House Owner's PAN no (optional)?
                </label>
              </div>
            </div>
            <p className={cx(styles['dateError'], 'text-center')}>
              {formErrors.dateError}
            </p>
            <div className={cx(styles['rentreceipt-subform'])}>
              <div className={cx(styles['input-box'])}>
                <span className={cx(styles['error'])}>
                  {formErrors.datefrom}
                </span>
                <input
                  aria-required="true"
                  id="DateFrom"
                  name="DateFrom"
                  placeholder="dd/mm/yyyy"
                  type="text"
                  value={this.props.data.datefrom}
                  onChange={this.props.handleChange}
                />
                <label className={cx(styles['active'])} htmlFor="DateFrom">
                  From when would you like to generate the rent receipt?
                </label>
              </div>
              <div className={cx(styles['input-box'])}>
                <span className={cx(styles['error'])}>{formErrors.dateto}</span>
                <input
                  aria-required="true"
                  id="DateTo"
                  name="DateTo"
                  placeholder="dd/mm/yyyy"
                  type="text"
                  value={this.props.data.dateto}
                  onChange={this.props.handleChange}
                />
                <label className={cx(styles['active'])} htmlFor="DateTo">
                  Till when would you like to generate the receipt?
                </label>
              </div>
            </div>
            <div
              className={cx(styles['input-box'], 'text-center')}
              style={{ maxWidth: '218px', margin: '0 auto' }}
            >
              <button
                className={cx('btn', styles['orange-btn'], {
                  [styles.disabled]: !formValid,
                })}
                name="Get receipt"
                value="Get Receipt"
                id="receipt-form-submit"
                disabled={!formValid}
                onClick={e => this.handleSubmitClick(e)}
              >
                {'Generate Receipts'.toUpperCase()}
              </button>
            </div>
          </div>
        ) : null}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/rent/webForm.tsx